import React, {useState} from 'react';
import datafile from "../information/Bio.json";
import GitHubFileUploader from "./GitHubFileUploader";
import Bio from "../components/pages/Bio";

const BioEditor = () => {
    const [data, setData] = useState(datafile);

    const handleTitleChange = (e) => {
        setData({...data, title: e.target.value});
    };

    const handleImageAdd = () => {
        const newImage = prompt('Enter image URL:');
        if (newImage) {
            setData({...data, carousel_images: [...data.carousel_images, newImage]});
        }
    };

    const handleImageDelete = (index) => {
        const updatedImages = data.carousel_images.filter((_, i) => i !== index);
        setData({...data, carousel_images: updatedImages});
    };

    const handleBioSectionAdd = () => {
        const newSection = {
            section_title: "New Bio Section",
            content: ["Edit this template information..."]
        };
        setData({...data, bio_sections: [...data.bio_sections, newSection]});
    };

    const handleSectionDelete = (index) => {
        const updatedSections = data.bio_sections.filter((_, i) => i !== index);
        setData({...data, bio_sections: updatedSections});
    };

    const handleBioFieldChange = (sectionIndex, field, subField, value) => {
        const updatedSections = data.bio_sections.map((section, index) => {
            if (index === sectionIndex) {
                const updatedSection = {...section};
                if (typeof updatedSection.content === 'object' && !Array.isArray(updatedSection.content)) {
                    if (subField) {
                        updatedSection.content[field][subField] = value;
                    } else {
                        updatedSection.content[field] = value;
                    }
                } else {
                    updatedSection.content[field] = value;
                }
                return updatedSection;
            }
            return section;
        });
        setData({...data, bio_sections: updatedSections});
    };

    const handleBioFieldAdd = (sectionIndex) => {
        const fieldName = prompt('Enter new field');
        if (fieldName) {
            const updatedSections = data.bio_sections.map((section, index) => {
                if (index === sectionIndex) {
                    const updatedSection = {...section};
                    if (Array.isArray(updatedSection.content)) {
                        updatedSection.content.push(fieldName);
                    } else {
                        updatedSection.content[fieldName] = {};
                    }
                    return updatedSection;
                }
                return section;
            });
            setData({...data, bio_sections: updatedSections});
        }
    };

    const handleBioFieldDelete = (sectionIndex, fieldKey) => {
        const updatedSections = data.bio_sections.map((section, index) => {
            if (index === sectionIndex) {
                const updatedSection = {...section};
                if (Array.isArray(updatedSection.content)) {
                    updatedSection.content.splice(fieldKey, 1);
                } else {
                    delete updatedSection.content[fieldKey];
                }
                return updatedSection;
            }
            return section;
        });
        setData({...data, bio_sections: updatedSections});
    };

    const handleSectionTitleChange = (index, newTitle) => {
        const updatedSections = data.bio_sections.map((section, sectionIndex) => {
            if (sectionIndex === index) {
                return {...section, section_title: newTitle};
            }
            return section;
        });
        setData({...data, bio_sections: updatedSections});
    };

    const moveSectionUp = (index) => {
        if (index > 0) {
            const updatedSections = [...data.bio_sections];
            [updatedSections[index - 1], updatedSections[index]] = [updatedSections[index], updatedSections[index - 1]];
            setData({...data, bio_sections: updatedSections});
        }
    };

    const moveSectionDown = (index) => {
        if (index < data.bio_sections.length - 1) {
            const updatedSections = [...data.bio_sections];
            [updatedSections[index + 1], updatedSections[index]] = [updatedSections[index], updatedSections[index + 1]];
            setData({...data, bio_sections: updatedSections});
        }
    };

    return (
        <>
            <div className="json-editor">

                <h2>Bio Editor</h2>

                <div className="editor-section">
                    <label>Title:</label>
                    <input
                        type="text"
                        value={data.title}
                        onChange={handleTitleChange}
                        className="title-input"
                    />
                </div>

                <div className="editor-section">
                    <label>Carousel Images:</label>
                    <ul>
                        {data.carousel_images.map((img, index) => (
                            <li key={index}>
                                {img}
                                <button onClick={() => handleImageDelete(index)} className="btn btn-danger">Delete
                                </button>
                            </li>
                        ))}
                    </ul>
                    <button onClick={handleImageAdd} className="btn btn-primary">Add Image</button>
                </div>

                <div className="editor-section">
                    <label>Bio Sections:</label>
                    {data.bio_sections.map((section, index) => (
                        <div key={index} className="bio-section">
                            <input
                                type="text"
                                value={section.section_title}
                                onChange={(e) => handleSectionTitleChange(index, e.target.value)}
                                className="section-title-input"
                            />
                            {Array.isArray(section.content) ? (
                                section.content.map((item, fieldIndex) => (
                                    <div key={fieldIndex} className="bio-field">
                                        <input
                                            type="text"
                                            value={item}
                                            onChange={(e) => handleBioFieldChange(index, fieldIndex, null, e.target.value)}
                                            className="input-field"
                                        />
                                        <button onClick={() => handleBioFieldDelete(index, fieldIndex)}
                                                className="btn btn-danger">Delete Field
                                        </button>
                                    </div>
                                ))
                            ) : (
                                Object.entries(section.content).map(([key, value]) => (
                                    <div key={key} className="bio-field">
                                        {typeof value === 'object' ? (
                                            Object.entries(value).map(([subKey, subValue]) => (
                                                <div key={subKey} className="bio-subfield">
                                                    <label>{subKey}:</label>
                                                    <input
                                                        type="text"
                                                        value={subValue}
                                                        onChange={(e) => handleBioFieldChange(index, key, subKey, e.target.value)}
                                                        className="input-field"
                                                    />
                                                </div>
                                            ))
                                        ) : (
                                            <div>
                                                <label>{key}:</label>
                                                <input
                                                    type="text"
                                                    value={value}
                                                    onChange={(e) => handleBioFieldChange(index, key, null, e.target.value)}
                                                    className="input-field"
                                                />
                                            </div>
                                        )}
                                        <button onClick={() => handleBioFieldDelete(index, key)}
                                                className="btn btn-danger">Delete Field
                                        </button>
                                    </div>
                                ))
                            )}
                            <button onClick={() => handleBioFieldAdd(index)} className="btn btn-secondary">Add Field
                            </button>
                            <button onClick={() => handleSectionDelete(index)} className="btn btn-danger">Delete
                                Section
                            </button>
                            <div className="move-buttons">
                                <button onClick={() => moveSectionUp(index)} className="btn btn-secondary">Move Up
                                </button>
                                <button onClick={() => moveSectionDown(index)} className="btn btn-secondary">Move Down
                                </button>
                            </div>
                        </div>
                    ))}
                    <button onClick={handleBioSectionAdd} className="btn btn-primary">Add Bio Section</button>
                </div>
            </div>
            <Bio bioData={data}/>
            <GitHubFileUploader jsonData={data} fileName={"Bio.json"}/>
        </>
    );
};

export default BioEditor;
